<template>
  <div v-if="showClearAllButton" class="checked-filters__wrapper">
    <div class="checked-filters">
      <ul>
        <li v-for="({ key, value }, index) in redo" :key="index">
          <template v-if="Object.keys(value)[0] === 'price'">
            <Badge class="badge" tag="button" @click="clearFilter(value)">
              <i class="icon icon-cross" />
              {{ formatCurrency(value.price.min) }} -
              {{ formatCurrency(value.price.max) }}
            </Badge>
          </template>
          <template v-else>
            <Badge class="badge" tag="button" @click="clearFilter(value)">
              <i class="icon icon-cross" />
              {{ key }}
            </Badge>
          </template>
        </li>
      </ul>
    </div>

    <div class="clear-filters">
      <Badge v-if="showClearAllButton" tag="button" @click="resetFilters">
        <i class="icon icon-cross" /> Clear all
      </Badge>
    </div>
  </div>
</template>

<script>
import Badge from "@/components/Badge.vue";
import { mapGetters } from "vuex";

export default {
  name: "SelectedFilters",
  components: {
    Badge,
  },
  props: {
    selectedFilters: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["clearFilter", "resetFilters"],
  computed: {
    ...mapGetters("app", ["moneyFormat"]),
    redo() {
      const values = this.selectedFilters.map((item) => {
        const key = Object.keys(item)[0];
        const valueString = item[key].value || Object.values(item)[0];
        if (key) {
          return { key: valueString, value: item };
        }
      });

      return values;
    },
    showClearAllButton() {
      return this.selectedFilters.length > 0;
    },
  },
  methods: {
    clearFilter(item) {
      this.$emit("clearFilter", item);
    },
    resetFilters() {
      this.$emit("resetFilters");
    },
    formatCurrency(value) {
      return this.moneyFormat.replace("{{amount}}", Math.round(value));
    },
  },
};
</script>

<style lang="scss" scoped>
.checked-filters {
  margin-bottom: 16px;

  ul {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }
}

.checked-filters__wrapper {
  margin-bottom: 20px;
}

.clear-filters {
  padding-top: 16px;
  border-top: 1px solid $color-grey;
}

::v-deep(.badge) .icon {
  margin-right: 4px;
}
</style>
